import type { Chat } from "@/reducers/chatsSlice"
import type { Profile } from "@/reducers/profilesSlice"
import i18n from "@/lib/i18n/i18n"

type AccountChats = Record<string, { driverA?: string } | undefined>

export function resolveDriverDisplayName(args: {
  chatJid?: string
  driverJid?: string
  chats: Chat[]
  profiles: Profile[]
  accountChats: AccountChats
}): string {
  const { chatJid, driverJid, chats, profiles, accountChats } = args

  const chat = chatJid ? chats.find((c) => c.jid === chatJid) : undefined

  if (chat) {
    const driverAJid = chatJid ? accountChats[chatJid]?.driverA : undefined
    const driverAProfile = driverAJid
      ? profiles.find((p) => p.jid === driverAJid)
      : undefined
    const driverParticipant = chat.participants?.find(
      (p) => p.role === "driver",
    )
    const effective = driverAProfile || driverParticipant
    if (effective) {
      if (
        "firstName" in effective &&
        effective.firstName &&
        effective.lastName
      ) {
        return `${effective.firstName} ${effective.lastName}`
      }
      return effective.name
    }
    return chat.name
  }

  return driverJid || i18n.t("reports.shared.unknown")
}
